import React from 'react'
import Loadable from 'react-loadable'
import { Progress } from 'reactstrap'

import DefaultLayout from './containers/DefaultLayout'

function Loading() {
  return <div>
    <Progress animated color="info" value="100" style={{ height: 10, }} />
  </div>
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
})

const RecordPage = Loadable({
  loader: () => import('./views/Pages/Record/RecordPage'),
  loading: Loading,
})

const CountryPage = Loadable({
  loader: () => import('./views/Pages/Chart/CountryPage'),
  loading: Loading,
})

const RegionPage = Loadable({
  loader: () => import('./views/Pages/Chart/RegionPage'),
  loading: Loading,
})

const HospitalPage = Loadable({
  loader: () => import('./views/Pages/Chart/HospitalPage'),
  loading: Loading,
})

const DepartmentPage = Loadable({
  loader: () => import('./views/Pages/Chart/DepartmentPage'),
  loading: Loading,
})

const WardPage = Loadable({
  loader: () => import('./views/Pages/Chart/WardPage'),
  loading: Loading,
})

const WardRegPage = Loadable({
  loader: () => import('./views/Pages/WardRegist/WardRegPage'),
  loading: Loading,
})

const UserProPage = Loadable({
  loader: () => import('./views/Pages/UserPro/UserPro'),
  loading: Loading,
})

const ManualPage = Loadable({
  loader: () => import('./views/Pages/Manual/ManualPage'),
  loading: Loading,
})

const SignOutPage = Loadable({
  loader: () => import('./views/Pages/SignOut/SignOutPage'),
  loading: Loading,
})

const Register = Loadable({
  loader: () => import('./views/Pages/Register/Register'),
  loading: Loading,
})

const Policy = Loadable({
  loader: () => import('./views/Pages/Login/Policy'),
  loading: Loading,
})

const TrainingPage = Loadable({
  loader: () => import('./views/Pages/Training/TrainingPage'),
  loading: Loading,
})

const AssessmentPage = Loadable({
  loader: () => import('./views/Pages/Assessment/AssessmentPage'),
  loading: Loading,
})

const Page404 = Loadable({
  loader: () => import('./views/Pages/Page404/Page404'),
  loading: Loading,
})

const Page500 = Loadable({
  loader: () => import('./views/Pages/Page500/Page500'),
  loading: Loading,
})

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/training', name: 'Training', component: TrainingPage }, 
  
  { path: '/HHintrodction', name: 'Training', component: TrainingPage }, 
  { path: '/HhyVdo', name: 'Training', component: TrainingPage }, 
  { path: '/5Moments', name: 'Training', component: TrainingPage }, 
  { path: '/HhAudit', name: 'Training', component: TrainingPage }, 
  { path: '/7Steps', name: 'Training', component: TrainingPage }, 
  { path: '/HandSurgery', name: 'Training', component: TrainingPage }, 

  { path: '/assessment', name: 'Assessment', component: AssessmentPage },
  { path: '/records', name: 'Record', component: RecordPage },
  { path: '/country', name: 'Country', component: CountryPage },
  { path: '/region', name: 'Region', component: RegionPage },
  { path: '/hospital', name: 'Hospital', component: HospitalPage },
  { path: '/department', name: 'Department', component: DepartmentPage },
  { path: '/ward', name: 'Ward', component: WardPage },
  { path: '/wardreg', name: 'Ward Register', component: WardRegPage },
  { path: '/userpro', name: 'Profile', component: UserProPage },
  { path: '/manual', name: 'Manual', component: ManualPage },
  { path: '/logout', name: 'Sign Out', component: SignOutPage },
  { path: '/register', name: 'register', component: Register },
  { path: '/policy', name: 'policy', component: Policy},
  
  { path: '/page404', name: 'page404', component: Page404 },
  { path: '/page500', name: 'page500', component: Page500},
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js